import { render, staticRenderFns } from "./companySettings.vue?vue&type=template&id=637d83ca&scoped=true"
import script from "./companySettings.vue?vue&type=script&lang=js"
export * from "./companySettings.vue?vue&type=script&lang=js"
import style0 from "./companySettings.vue?vue&type=style&index=0&id=637d83ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637d83ca",
  null
  
)

export default component.exports